import { useGblz } from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const itl_42z = () => ({  // 新規登録を考慮し、毎回新規生成
  _42rz: {},
  _421s: [],
}) as ht.dz;

export const crt_42z = async (pz: {
  _10r_key: ht.n,
}) => {
  const _gUserz = useGblz('user');
  const __42z = itl_42z();
  hf.udtDz(__42z._42rz, {
    ... ihd.i('_42r'),
    _42r_31r1f: _gUserz.crt._31rz._fst,
    _42r_10r1k: pz._10r_key,
  });
  __42z._421s = [];
  return __42z;
};

export const load_42rDzAsync = async (pz: {
  _10r_key?: ht.n,
  _42r_fst?: ht.n,
  cdn: ht.s,
  vsn?: ht.n,
}) => {
//  let _cdn = f.vdd();
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (f.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : f.vdd();
  if (pz._10r_key) _cdn += ` AND _42r_10r1k = ${pz._10r_key}`;
  if (pz._42r_fst) _cdn += ` AND _fst = ${pz._42r_fst}`;
  _cdn += ` AND (${pz.cdn})`;
  const _dz = await f.loadDzAsync({
    tgt: '_42rs',
    cdn: _cdn,
    fld: '*',
    lwrz: {
      _421s: {
        tgt: '_421s',
        cdn: f.vdd(false) + ` AND _421_42r1k = {_42r_key}`,
        rlcz: {
          _42r_key: '_42rs._key',
        },
        fld: '*',
      },
    }
  });
  return {
    _42rz: { ... _dz, cldz: undefined },
    _421s: _dz.cldz?._421s ?? [],
  };
};

export const save_42rDzAsync = async (pz: {
  _42z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _dz = await f.ugdDzAsync({
    tgt: '_42rs',
    dz: {
      ... pz._42z._42rz,
    },
    lwrz: {
      _421s: {
        tgt: '_421s',
        ls: pz._42z._421s,
/*
        rlcz: {
          _421_31r1f: '_42rs._42r_31r1f',
          _421_42r1k: '_42rs._key',
        }
*/
        udtz: {
          _421_31r1f: '_42rs._42r_31r1f',
          _421_42r1k: '_42rs._key',
        }
      },
    }
  });
  if (pz.sPz) pz.sPz.set({
    _fst: _dz._fst,
    _key: _dz._key,
  })
  return {
    _42rz: { ... _dz, cldz: undefined },
  };
};
